import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight, ArrowRight } from 'lucide-react';

// Ordered area keys → slugs. Reihenfolge wie zuvor.
const AREAS = [
  { k: 'AUSLAENDERRECHT', slug: 'auslaenderrecht' },
  { k: 'STRAFRECHT', slug: 'strafrecht' },
  { k: 'STEUERBERATUNG', slug: 'steuerberatung' },
  { k: 'STEUERRECHT', slug: 'steuerrecht' },
  { k: 'GESELLSCHAFTSRECHT', slug: 'gesellschaftsrecht' },
  { k: 'VERWALTUNGSRECHT', slug: 'verwaltungsrecht' },
  { k: 'MIETRECHT', slug: 'mietrecht' },
  { k: 'VERKEHRSRECHT', slug: 'verkehrsrecht' },
];

const SpecialAreas = () => {
  const { t } = useTranslation();
  const areasMap = t('specialAreas.areas', { returnObjects: true }) || {};

  return (
    <section id="spezialgebiete" className="bg-[#eaf1f5] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <h2 className="font-serif font-light text-[#1B3A5C] text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight mb-16">
          {t('specialAreas.eyebrow', 'SPEZIAL-GEBIETE')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {AREAS.map(({ k, slug }) => {
            const area = areasMap[k] || { title: k, items: [] };
            const items = Array.isArray(area.items) ? area.items : [];
            return (
              <Link
                key={k}
                to={`/rechtsgebiete/${slug}`}
                data-testid={`special-area-${slug}`}
                className="group block bg-white/40 hover:bg-white p-6 rounded-sm transition-all duration-300 border-l-2 border-[#b8893d]/30 hover:border-[#b8893d] hover:shadow-lg cursor-pointer"
              >
                <h3 className="text-[#1B3A5C] font-semibold text-base tracking-[0.15em] mb-4 pb-3 border-b border-[#1B3A5C]/15 flex items-center justify-between">
                  <span>{area.title}</span>
                  <ArrowRight className="w-4 h-4 text-[#b8893d] opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                </h3>
                <ul className="space-y-2.5">
                  {items.map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-2 text-[#34536b] text-[13px] tracking-wide"
                    >
                      <ChevronRight className="w-3.5 h-3.5 text-[#b8893d] mt-0.5 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-4 text-[10px] tracking-[0.2em] text-[#b8893d] opacity-0 group-hover:opacity-100 transition-opacity">
                  {t('specialAreas.cta_more', 'MEHR ERFAHREN →')}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SpecialAreas;
